import React, { useState } from 'react';
import { ContentData } from '../data/contentData';

interface ClubsPageProps {
  content: ContentData;
}

const ClubsPage: React.FC<ClubsPageProps> = ({ content }) => {
  const [selectedClub, setSelectedClub] = useState<string | null>(null);

  const clubs = [
    {
      id: 'math',
      name: 'গণিত ক্লাব',
      englishName: 'Mathematics Club',
      icon: '🔢',
      color: 'from-blue-500 to-cyan-500',
      description: 'গণিতের জটিল সমস্যা সমাধান ও গণিত অলিম্পিয়াডের জন্য প্রস্তুতি',
      president: 'মো. রফিকুল ইসলাম',
      vicePresident: 'ড. ফাতেমা বেগম',
      members: 45,
      established: '২০১৮',
      activities: [
        'মাসিক গণিত কুইজ প্রতিযোগিতা',
        'গণিত অলিম্পিয়াড প্রস্তুতি',
        'গণিত সমস্যা সমাধান সেশন',
        'গণিত সেমিনার ও কর্মশালা',
        'গণিত মেলা আয়োজন'
      ],
      achievements: [
        'জাতীয় গণিত অলিম্পিয়াডে ৩টি স্বর্ণপদক',
        'আঞ্চলিক গণিত প্রতিযোগিতায় ১ম স্থান',
        'বছরে ৫টি গণিত সেমিনার আয়োজন'
      ],
      meetingTime: 'প্রতি শুক্রবার বিকাল ৪:০০',
      room: 'রুম ১০১'
    },
    {
      id: 'science',
      name: 'বিজ্ঞান ক্লাব',
      englishName: 'Science Club',
      icon: '🔬',
      color: 'from-green-500 to-emerald-500',
      description: 'বৈজ্ঞানিক গবেষণা, পরীক্ষা ও উদ্ভাবনী চিন্তার বিকাশ',
      president: 'ড. নাসির উদ্দিন',
      vicePresident: 'মো. সাকিব আহমেদ',
      members: 52,
      established: '২০১৭',
      activities: [
        'বৈজ্ঞানিক পরীক্ষা ও গবেষণা',
        'বিজ্ঞান মেলা আয়োজন',
        'বিজ্ঞান প্রকল্প প্রদর্শনী',
        'বিজ্ঞান সেমিনার',
        'পরিবেশ সচেতনতা কার্যক্রম'
      ],
      achievements: [
        'জাতীয় বিজ্ঞান মেলায় ২টি পুরস্কার',
        'বিজ্ঞান প্রকল্পে আন্তর্জাতিক স্বীকৃতি',
        'পরিবেশ সচেতনতা কার্যক্রমে প্রশংসা'
      ],
      meetingTime: 'প্রতি বুধবার বিকাল ৩:৩০',
      room: 'বিজ্ঞান ল্যাব'
    },
    {
      id: 'debate',
      name: 'বিতর্ক ক্লাব',
      englishName: 'Debate Club',
      icon: '🎤',
      color: 'from-purple-500 to-pink-500',
      description: 'বিতর্ক দক্ষতা উন্নয়ন, যুক্তি-তর্ক ও বক্তৃতা শিল্পের চর্চা',
      president: 'ড. রোকসানা খাতুন',
      vicePresident: 'মো. আব্দুল হামিদ',
      members: 38,
      established: '২০১৯',
      activities: [
        'সাপ্তাহিক বিতর্ক সেশন',
        'বিতর্ক প্রতিযোগিতা আয়োজন',
        'বক্তৃতা প্রশিক্ষণ',
        'যুক্তি-তর্ক চর্চা',
        'বিতর্ক কর্মশালা'
      ],
      achievements: [
        'জাতীয় বিতর্ক প্রতিযোগিতায় ১ম স্থান',
        'আঞ্চলিক বিতর্কে ৩টি পুরস্কার',
        'বিতর্ক কর্মশালায় ১০০+ শিক্ষার্থী অংশগ্রহণ'
      ],
      meetingTime: 'প্রতি সোমবার বিকাল ৪:৩০',
      room: 'অডিটোরিয়াম'
    },
    {
      id: 'cultural',
      name: 'সাংস্কৃতিক ক্লাব',
      englishName: 'Cultural Club',
      icon: '🎭',
      color: 'from-orange-500 to-red-500',
      description: 'বাংলা সংস্কৃতি, নাটক, গান, নৃত্য ও সৃজনশীল কার্যক্রম',
      president: 'ড. রুমানা পারভীন',
      vicePresident: 'মো. করিম উদ্দিন',
      members: 65,
      established: '২০১৬',
      activities: [
        'নাটক ও অভিনয় চর্চা',
        'গান ও নৃত্যের প্রশিক্ষণ',
        'সাংস্কৃতিক অনুষ্ঠান আয়োজন',
        'বাংলা সাহিত্য চর্চা',
        'ঐতিহ্য সংরক্ষণ কার্যক্রম'
      ],
      achievements: [
        'জাতীয় সাংস্কৃতিক প্রতিযোগিতায় ২টি পুরস্কার',
        'নাটক মঞ্চায়নে প্রশংসা',
        'বাংলা সাহিত্যে বিশেষ অবদান'
      ],
      meetingTime: 'প্রতি মঙ্গলবার বিকাল ৩:০০',
      room: 'সাংস্কৃতিক কেন্দ্র'
    },
    {
      id: 'sports',
      name: 'ক্রীড়া ক্লাব',
      englishName: 'Sports Club',
      icon: '⚽',
      color: 'from-yellow-500 to-orange-500',
      description: 'বিভিন্ন খেলাধুলা, ফিটনেস ও শারীরিক সুস্থতা',
      president: 'মো. রহমান আলী',
      vicePresident: 'ড. ফারহানা ইয়াসমিন',
      members: 78,
      established: '২০১৫',
      activities: [
        'ফুটবল, ক্রিকেট, ভলিবল প্রশিক্ষণ',
        'ব্যাডমিন্টন ও টেবিল টেনিস',
        'অ্যাথলেটিক্স ও দৌড়',
        'ফিটনেস কার্যক্রম',
        'খেলাধুলা প্রতিযোগিতা'
      ],
      achievements: [
        'জেলা ক্রিকেটে ১ম স্থান',
        'ফুটবল টুর্নামেন্টে ২টি ট্রফি',
        'অ্যাথলেটিক্সে ৫টি স্বর্ণপদক'
      ],
      meetingTime: 'প্রতি শনিবার সকাল ৭:০০',
      room: 'খেলার মাঠ'
    },
    {
      id: 'career',
      name: 'ক্যারিয়ার বিল্ডিং ক্লাব',
      englishName: 'Career Building Club',
      icon: '💼',
      color: 'from-indigo-500 to-purple-500',
      description: 'ক্যারিয়ার পরিকল্পনা, দক্ষতা উন্নয়ন ও ভবিষ্যতের প্রস্তুতি',
      president: 'ড. নাসিরা খাতুন',
      vicePresident: 'মো. আবুল হোসেন',
      members: 42,
      established: '২০২০',
      activities: [
        'ক্যারিয়ার কাউন্সেলিং',
        'দক্ষতা উন্নয়ন কর্মশালা',
        'ইন্টারভিউ প্রস্তুতি',
        'রেজুমি লেখার প্রশিক্ষণ',
        'ক্যারিয়ার সেমিনার'
      ],
      achievements: [
        '১০০+ শিক্ষার্থীর ক্যারিয়ার গাইডেন্স',
        'ইন্টারভিউ প্রস্তুতিতে ৯৫% সফলতা',
        'ক্যারিয়ার কর্মশালায় প্রশংসা'
      ],
      meetingTime: 'প্রতি বৃহস্পতিবার বিকাল ৪:০০',
      room: 'ক্যারিয়ার কেন্দ্র'
    }
  ];

  const upcomingEvents = [
    {
      title: 'গণিত অলিম্পিয়াড ২০২৪',
      club: 'গণিত ক্লাব',
      date: '১৫ মার্চ, ২০২৪',
      time: 'সকাল ১০:০০',
      location: 'অডিটোরিয়াম',
      description: 'জাতীয় গণিত অলিম্পিয়াডের প্রস্তুতি'
    },
    {
      title: 'বিজ্ঞান মেলা ২০২৪',
      club: 'বিজ্ঞান ক্লাব',
      date: '২২ মার্চ, ২০২৪',
      time: 'সকাল ৯:০০',
      location: 'বিজ্ঞান ল্যাব',
      description: 'বিজ্ঞান প্রকল্প প্রদর্শনী ও প্রতিযোগিতা'
    },
    {
      title: 'বিতর্ক প্রতিযোগিতা',
      club: 'বিতর্ক ক্লাব',
      date: '২৮ মার্চ, ২০২৪',
      time: 'বিকাল ৩:০০',
      location: 'অডিটোরিয়াম',
      description: 'বছরের সেরা বিতার্কিক নির্বাচন'
    },
    {
      title: 'সাংস্কৃতিক অনুষ্ঠান',
      club: 'সাংস্কৃতিক ক্লাব',
      date: '৫ এপ্রিল, ২০২৪',
      time: 'সন্ধ্যা ৬:০০',
      location: 'সাংস্কৃতিক কেন্দ্র',
      description: 'বাংলা নববর্ষ উদযাপন'
    }
  ];

  const clubStats = {
    totalClubs: clubs.length,
    totalMembers: clubs.reduce((sum, club) => sum + club.members, 0),
    activeEvents: upcomingEvents.length,
    establishedYears: Math.max(...clubs.map(club => parseInt(club.established)))
  };

  return (
    <div className="py-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 bangla-font">{content.clubs.title}</h1>
          <p className="text-lg text-gray-600 bangla-font">সৃজনশীলতা, দক্ষতা ও নেতৃত্বের বিকাশ</p>
        </div>

        {/* Club Statistics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <div className="text-3xl font-bold text-blue-600 mb-2">{clubStats.totalClubs}</div>
            <div className="text-gray-600 bangla-font">মোট ক্লাব</div>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <div className="text-3xl font-bold text-green-600 mb-2">{clubStats.totalMembers}</div>
            <div className="text-gray-600 bangla-font">সদস্য সংখ্যা</div>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <div className="text-3xl font-bold text-purple-600 mb-2">{clubStats.activeEvents}</div>
            <div className="text-gray-600 bangla-font">সক্রিয় ইভেন্ট</div>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <div className="text-3xl font-bold text-orange-600 mb-2">{clubStats.establishedYears}</div>
            <div className="text-gray-600 bangla-font">প্রতিষ্ঠার বছর</div>
          </div>
        </div>

        {/* Clubs Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {clubs.map((club) => (
            <div
              key={club.id}
              className={`bg-gradient-to-br ${club.color} rounded-lg shadow-lg p-6 text-white cursor-pointer transform hover:scale-105 transition-all duration-200`}
              onClick={() => setSelectedClub(selectedClub === club.id ? null : club.id)}
            >
              <div className="text-5xl mb-4 text-center">{club.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-center bangla-font">{club.name}</h3>
              <p className="text-sm text-center mb-4 opacity-90 bangla-font">{club.englishName}</p>
              <p className="text-sm mb-4 opacity-90 bangla-font">{club.description}</p>
              
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="font-semibold bangla-font">সদস্য:</span>
                  <div className="bangla-font">{club.members} জন</div>
                </div>
                <div>
                  <span className="font-semibold bangla-font">প্রতিষ্ঠা:</span>
                  <div className="bangla-font">{club.established}</div>
                </div>
              </div>
              
              <div className="mt-4 text-center">
                <span className="text-xs opacity-75 bangla-font">
                  {selectedClub === club.id ? 'বিস্তারিত দেখুন' : 'ক্লিক করে বিস্তারিত দেখুন'}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Club Details Modal */}
        {selectedClub && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              {(() => {
                const club = clubs.find(c => c.id === selectedClub);
                if (!club) return null;
                
                return (
                  <div className="p-8">
                    <div className="flex justify-between items-start mb-6">
                      <div className="flex items-center space-x-4">
                        <div className="text-6xl">{club.icon}</div>
                        <div>
                          <h2 className="text-3xl font-bold text-gray-900 bangla-font">{club.name}</h2>
                          <p className="text-gray-600 bangla-font">{club.englishName}</p>
                        </div>
                      </div>
                      <button
                        onClick={() => setSelectedClub(null)}
                        className="text-gray-400 hover:text-gray-600 text-2xl"
                      >
                        ×
                      </button>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-4 bangla-font">ক্লাবের বিবরণ</h3>
                        <p className="text-gray-600 mb-6 bangla-font">{club.description}</p>

                        <h3 className="text-xl font-semibold text-gray-900 mb-4 bangla-font">নেতৃত্ব</h3>
                        <div className="space-y-2 mb-6">
                          <div className="flex justify-between">
                            <span className="bangla-font">সভাপতি:</span>
                            <span className="text-gray-600 bangla-font">{club.president}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="bangla-font">সহ-সভাপতি:</span>
                            <span className="text-gray-600 bangla-font">{club.vicePresident}</span>
                          </div>
                        </div>

                        <h3 className="text-xl font-semibold text-gray-900 mb-4 bangla-font">মিটিং তথ্য</h3>
                        <div className="space-y-2 mb-6">
                          <div className="flex justify-between">
                            <span className="bangla-font">সময়:</span>
                            <span className="text-gray-600 bangla-font">{club.meetingTime}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="bangla-font">স্থান:</span>
                            <span className="text-gray-600 bangla-font">{club.room}</span>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-4 bangla-font">কার্যক্রম</h3>
                        <ul className="space-y-2 mb-6">
                          {club.activities.map((activity, index) => (
                            <li key={index} className="text-gray-600 bangla-font flex items-start">
                              <span className="text-blue-500 mr-2">•</span>
                              {activity}
                            </li>
                          ))}
                        </ul>

                        <h3 className="text-xl font-semibold text-gray-900 mb-4 bangla-font">অর্জন</h3>
                        <ul className="space-y-2">
                          {club.achievements.map((achievement, index) => (
                            <li key={index} className="text-gray-600 bangla-font flex items-start">
                              <span className="text-green-500 mr-2">•</span>
                              {achievement}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        )}

        {/* Upcoming Events */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center bangla-font">আসন্ন ইভেন্টসমূহ</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {upcomingEvents.map((event, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900 bangla-font">{event.title}</h3>
                  <span className="text-sm text-blue-600 bangla-font">{event.club}</span>
                </div>
                <p className="text-gray-600 mb-4 bangla-font">{event.description}</p>
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span className="font-semibold text-gray-700 bangla-font">তারিখ:</span>
                    <div className="text-gray-600 bangla-font">{event.date}</div>
                  </div>
                  <div>
                    <span className="font-semibold text-gray-700 bangla-font">সময়:</span>
                    <div className="text-gray-600 bangla-font">{event.time}</div>
                  </div>
                  <div>
                    <span className="font-semibold text-gray-700 bangla-font">স্থান:</span>
                    <div className="text-gray-600 bangla-font">{event.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Join Club CTA */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-8 text-white text-center">
          <h2 className="text-3xl font-bold mb-4 bangla-font">ক্লাবে যোগ দিন</h2>
          <p className="text-lg mb-6 bangla-font">আপনার আগ্রহ অনুযায়ী ক্লাব বেছে নিন এবং আপনার দক্ষতা বিকাশ করুন</p>
          <div className="flex flex-wrap justify-center gap-4">
            <button className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors bangla-font">
              ক্লাব সম্পর্কে জানুন
            </button>
            <button className="border-2 border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors bangla-font">
              যোগাযোগ করুন
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClubsPage;
